import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgArrowLeft = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M17.03 9.258H5.604l6.84-5.938a.155.155 0 00-.102-.273h-1.728a.313.313 0 00-.205.076L3.027 9.527a.624.624 0 000 .944l7.423 6.443c.03.025.065.04.102.04h1.787c.145 0 .211-.18.102-.274l-6.838-5.938H17.03c.085 0 .156-.07.156-.156V9.414a.157.157 0 00-.157-.156z" />
    </Icon>
  );
};

export default SvgArrowLeft;
